module.exports = __webpack_public_path__ + "static/media/peter.a914718d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/finals/portfolios/peter.png
// module id = 285
// module chunks = 0